module.exports = __webpack_public_path__ + "static/img/icon-export-blue.bf2d377f.svg";